import API from 'utils/api';
import { ESTATUS_AUTORIZADO } from 'utils/constants';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/registro_contable_ipejal';

/**
 * GET Cuentas Contables IPEJAL
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCuentasContablesIPEJAL = async (params) => {
  try {
    const response = await API.get(`${baseURI}`, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Cuenta Contable IPEJAL
 * @param {object} id
 * @returns {Promise<object|null>}
 */
export const getCuentaContableIPEJAL = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Cuenta Contable IPEJAL
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCuentaContableIPEJAL = async (values) => {
  try {
    const response = await API.post(`${baseURI}`, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Cuenta Contable
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCuentaContableIPEJAL = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Cuenta Contable
 * @param {number} id
 * @return {Promise<boolean>}
 */
export const deleteCuentaContableIPEJAL = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR IPEJAL Registro Presupuestal
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarCuentaContableIPEJAL = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
